import React from "react";
import {Tab, Tabs} from "@mui/material";
import TabPanel from "./TabPanel";
import { makeStyles } from '@mui/styles';
const a11yProps = (index) => {
    return {
        id: `tabpanel-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: '100%',
        minHeight: 700
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        padding: '2% 0',
        width: 350
    },
}));

const VerticalTabs = ({value, setValue, elements}) => {
    const classes = useStyles();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const tabs = Object.keys(elements);
    const contents = Object.values(elements);

    return <div className={classes.root}>
        <Tabs
            orientation="vertical"
            // variant="fullWidth"

            variant="scrollable"
            scrollButtons="auto"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
        >
            {
                tabs.length > 0 && tabs.map((tab, idx) => <Tab key={idx} icon={contents[idx].icon} label={tab} {...a11yProps(idx)} />)
            }
        </Tabs>

        {
            contents.length > 0 && contents.map((content, idx) => <TabPanel key={idx} value={value} index={idx}>
                {content.component}
            </TabPanel>)
        }
    </div>
}

export default VerticalTabs
